module.exports = __webpack_public_path__ + "media/images/steps/step_9-8f2c445ef8bbc9184f606e6c169d6b88.svg";